export const colors = {
  main: '#76BC21',
  white: '#FFF',
  blue: '#002856',
  grey1: '#F0F2F5',
  grey2: '#333'
}
